import React, { forwardRef, useImperativeHandle } from 'react';
import ConfirmModal from 'components/common/ConfirmModal';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
const WorkCalenderOvertimeWarningModal = forwardRef((props, ref) => {
    const {t} = useTranslation();

    useImperativeHandle(ref, () => ({
        resetForm: () => {
            console.log(props);
        },
        setFrom: (values) => {

        }
    }));
    const form = useFormik({
    });

    const test123 = () => {
        props.setIsOpen(false);
    }

    return (
        <ConfirmModal
            isOpen={props?.isOpen}
            setIsOpen={props?.setIsOpen}
            title={t('issuePopup.overWorkingTime')}
            description={t('approval.applyNotPosible')}
            confirmText={t('확인')}
            onConfirm={() => {test123();}}
            hideCancel={true}
        />
    );
});

export default WorkCalenderOvertimeWarningModal;
